// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-presentation_register-design__DOPHf {
  background-color: var(--secondary-background-color);
  border-radius: 6px;
  padding: 32px;
  display: flex;
  justify-content: center;
}

.register-presentation_illustration-container__YwkgS {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 32px;
  max-width: 400px;
  min-width: 200px;
}

.register-presentation_illustration-image__Rzy1u {
  max-width: 300px;
  border-radius: 6px;
}

.register-presentation_illustration-description__NG1o8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.register-presentation_partners__8qOD1 {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/register/register-presentation.module.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB","sourcesContent":[".register-design {\n  background-color: var(--secondary-background-color);\n  border-radius: 6px;\n  padding: 32px;\n  display: flex;\n  justify-content: center;\n}\n\n.illustration-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 32px;\n  max-width: 400px;\n  min-width: 200px;\n}\n\n.illustration-image {\n  max-width: 300px;\n  border-radius: 6px;\n}\n\n.illustration-description {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.partners {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"register-design": `register-presentation_register-design__DOPHf`,
	"illustration-container": `register-presentation_illustration-container__YwkgS`,
	"illustration-image": `register-presentation_illustration-image__Rzy1u`,
	"illustration-description": `register-presentation_illustration-description__NG1o8`,
	"partners": `register-presentation_partners__8qOD1`
};
export default ___CSS_LOADER_EXPORT___;
